const EventEmitter = require('events').EventEmitter;
const WebSocketEventEmitter = new EventEmitter();

module.exports = { WebSocketEventEmitter };

